import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { Opportunity } from "../../../models/opportunity";
import { SavedOpportunity } from "../../../models/profile";
import { CircularProgress } from "material-ui/Progress";
import { ScreenMode, SavedOpportunityState, ApplicationProcess, EmptyId, BusyEvent } from "../../../models/enums";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import * as s from "./actions.css";

@inject("store") @observer
export class SaveAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  handleAddOp = (op:Opportunity, savedOp:SavedOpportunity): void => {
    if (!savedOp || (savedOp.status & SavedOpportunityState.Saved) === 0) {
      this.props.store.profileStore.watchOpportunity(op);
    }
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const op: Opportunity = this.props.store.opportunityStore.selectedOp;
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(op.idHash);
    const isSaved: boolean = savedOp && (savedOp.status & SavedOpportunityState.Saved) > 0;

    const cls: string = mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktop : s.ssActionBtnTextTablet;
    return (<Paper elevation={5} className={s.box}>
      <div onClick={() => this.handleAddOp(op, savedOp)} className={s.clickableBox} >
        <Row middle="xs" className={s.contentRow}>
          <Col xs={12}>
            {!isSaved && <img src={local.icons.addStar} className={s.ssActionBtnIcon} />}
            {isSaved && <img src={local.icons.savedToLibrary} className={s.ssActionBtnIcon} />}
          </Col>
          <Col xs={12}>
            {!isSaved && <p className={cls}>{local.opportunity.actionSaveText}</p>}
            {isSaved && <p className={cls}>{local.opportunity.actionIsSavedText}</p>}
          </Col>
        </Row>
      </div>
    </Paper>)
  }
}

@inject("store") @observer
export class ApplyAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  handleApply = (hasApplied: boolean): void => {
    if (!hasApplied) {
      const func: (op?: Opportunity) => void = this.props.store.opportunityStore.getApplicationFunction();
      func();
    } else {
      this.props.store.viewState.setShowConfirmationDlg(true);
    }
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const op: Opportunity = this.props.store.opportunityStore.selectedOp;
    if (!op) {
      return null;
    }
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(op.idHash);
    if (!savedOp) {
      return null;
    }
    const hasApplied: boolean = (savedOp.status & SavedOpportunityState.Applied) > 0; 

    return (<Paper elevation={5} className={s.box}>
      <div onClick={() => this.handleApply(hasApplied)} className={s.clickableBox} >
        <Row middle="xs" className={s.contentRow}>
          <Col xs={12}>
            {!hasApplied && < img src={local.icons.applyform} className={s.ssActionBtnIcon} />}
            {hasApplied && <img src={local.icons.appliedConfirmed} className={s.ssActionBtnIcon} />}
          </Col>
          <Col xs={12}>
            {!hasApplied && <p className={mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktop : s.ssActionBtnTextTablet}>{local.opportunity.actionApplyText}</p>}
            {hasApplied && <p className={mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktop : s.ssActionBtnTextTablet}>{local.opportunity.applicationSubmitted}</p>}
          </Col>
        </Row>
      </div>
    </Paper>)
  }
}


@inject("store") @observer
export class NoApplyAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  handleApply = (): void => {
    const func: (op?: Opportunity) => void = this.props.store.opportunityStore.getApplicationFunction();
    func();
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<Paper elevation={5} className={s.box}>
      <div className={s.clickableBox} >
        <Row middle="xs" className={s.contentRow}>
          <Col xs={12}>
            <img src={local.icons.noApplication} className={s.ssActionBtnIcon} />
          </Col>
          <Col xs={12}>
            <p className={mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktop : s.ssActionBtnTextTablet}>{local.opportunity.notOpen}</p>
          </Col>
        </Row>
      </div>
    </Paper>)
  }
}


@inject("store") @observer
export class DownloadPdfAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }


  renderEnabled(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const op: Opportunity = this.props.store.opportunityStore.selectedOp;

    return (<Paper elevation={5} className={s.box}>
      <div onClick={() => this.props.store.opportunityStore.generateProfile(op ? op.idHash : EmptyId)} className={s.clickableBox} >
        <Row middle="xs" className={s.contentRow}>
          <Col xs={12}>
            {!this.props.store.viewState.isBusy(BusyEvent.GeneratingProfile) && <img src={local.icons.pdf} className={s.ssActionBtnIcon} />}
            {this.props.store.viewState.isBusy(BusyEvent.GeneratingProfile) && <div>{local.generating}</div>}
          </Col>
          <Col xs={12}>
            <p className={mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktop : s.ssActionBtnTextTablet}>{local.opportunity.actionPdfText}</p>
          </Col>
        </Row>
      </div>
    </Paper>)
  }

  renderDisabled(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;

    return (<Paper elevation={5} className={s.box}>
      <div>
        <Row middle="xs" className={s.contentRow}>
          <Col xs={12}>
             <img src={local.icons.pdf} className={s.ssActionBtnIcon} />
          </Col>
          <Col xs={12}>
            <p className={mode === ScreenMode.Desktop ? s.ssActionBtnTextDesktopDisabled : s.ssActionBtnTextTabletDisabled}>{local.opportunity.noProfile}</p>
          </Col>
        </Row>
      </div>
    </Paper>)
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const op: Opportunity = this.props.store.opportunityStore.selectedOp;
    const enable: boolean = (this.props.store.profileStore.profile.skills.length > 0 ||
      this.props.store.profileStore.profile.jobs.length > 0 ||
      this.props.store.profileStore.profile.educations.length > 0 ||
      this.props.store.profileStore.profile.activities.length > 0);
    return (<div>
      {enable && this.renderEnabled()}
      {!enable && this.renderDisabled()}
    </div>)
  }
}

@observer
export class ConfirmationDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  handleApply = (): void => {
    this.props.store.viewState.closeConfirmationDlg();
    const func: (op?: Opportunity) => void = this.props.store.opportunityStore.getApplicationFunction();
    func();
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const msg: string = local.opportunity.applyDuplicateDialogMessage;
    return (<Dialog
      fullScreen={false}
      open={this.props.store.viewState.showConfirmationDlg}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle id="responsive-dialog-title">{local.opportunity.applyDuplicateDialogHeader}</DialogTitle>
      <DialogContent>
        {msg}
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.store.viewState.closeConfirmationDlg} color="secondary" >{local.opportunity.goBack}</Button>
        <Button onClick={this.handleApply} color="secondary" >{local.opportunity.proceed}</Button>
      </DialogActions>
    </Dialog>);
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/actions/index.tsx